import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from "@angular/core";
import { Router } from "@angular/router";
import { AlertButton, IonicModule } from "@ionic/angular";
import { AlertModel } from "src/app/core/models/alert.model";
import { AlertService } from "src/app/core/services/alert.service";
import { AppService } from "src/app/core/services/app.service";
import { AuthService } from "src/app/core/services/auth.service";
import { Console } from "../../providers/custom-logger";

@Component({
  selector: "app-logout",
  templateUrl: "./logout.component.html",
  styleUrls: ["./logout.component.scss"],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
  imports: [IonicModule],
})
export class LogoutComponent {
  private log_label = "LogoutComponent";
  private alertOpt: AlertModel = new AlertModel();
  name = "Esci";
  icon = "power";

  private router = inject(Router);
  private authService = inject(AuthService);
  private appService = inject(AppService);
  private alertService = inject(AlertService);

  async LogoutComponent() {
    /* signOut(): sessione SSO → Auth-App landing; sessione legacy → API logout + /login. */
    let buttons: AlertButton[] = [
      {
        text: "No",
        role: "cancel",
      },
      {
        text: "Si",
        handler: (data) => {
          Console.log(this.log_label + " data alert: ", data);
          this.authService.triggerSignOut();
        }
      }
    ];
    this.alertOpt.header = "Confermi di voler uscire?";
    this.alertOpt.buttons = buttons;
    this.alertService.presentAlert(this.alertOpt);
  }
}
